import {
    Grid } from "../../ui";
import useUiController from "../../global/hooks/useUiController";
import SnpBaseLayout from "../../global/SnpBaseLayout";
import { useEffect,
    useState } from "react";
import { useLocation,
    useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  CART_INITIAL_STATE,
  getPreUrlAccordingToCart,
  isEmpty,
  printDebugLog,
  SUCCESS
} from "../../../constants/constant";
import { snpAxios } from "../../global/api";
import SnpButton from "../../global/SnpButton";
import ImageNotSupportedIcon from '../../ui/icons/ImageNotSupported';
import CustomDataGrid from "../../global/CustomDataGrid";

const ShowGoldSupplierRecord = () => {

    const {
        loader,
        setLoader,
        snackbarConfig,
        closeSnackbar,
        dialogConfig,
    } = useUiController();


    const location = useLocation();
    const navigate = useNavigate();
    const storeActiveShopHash = useSelector(state => state.setActiveShopHashReducer.activeShopHash);
    const storeApiUrl = useSelector(state => state.setApiUrlReducer.MAINURL.INITIAL_BASE_URL);

    const [listRecords, setListRecords] = useState([]);
    const [supplierData, setSupplierData] = useState([]);


    const [listSupId, setListSupId] = useState([]);
    const [inventoryId, setInventoryId] = useState("");

    const getSupplierDetails = async () => {
        try {
            const cartUrl = `${storeApiUrl.BACKEND_BASE_URL}${getPreUrlAccordingToCart(storeActiveShopHash.cartType)}fetch-supplier-few-details?token=${CART_INITIAL_STATE.apiToken}&shopHash=${storeActiveShopHash.id}`;
            const response = await snpAxios.get(cartUrl);
            if (response.data.status === SUCCESS) {
                setSupplierData(response.data.jcJson.value_2);
            }
        } catch (e) {
            console.log("getSupplierDetails errr ", e);
        }
    };

    const getProductDetails = async (inventoryId, listSupplierId = []) => {
        try {
            setLoader(true);
            const cartUrl = `${storeApiUrl.BACKEND_BASE_URL}${getPreUrlAccordingToCart(storeActiveShopHash.cartType)}get-gold-supplier-record`;
            const data = {
                jcJson: {
                    apiToken: CART_INITIAL_STATE.apiToken,
                    shopHash: storeActiveShopHash.id,
                    inventoryId: inventoryId,
                    listSupplierId: listSupplierId,
                }
            }
            const response = await snpAxios.post(cartUrl, data);
            if (response.data.status === SUCCESS) {
                const payLoad = response.data.jcJson;
                setListRecords(payLoad.fullData);
            } else {
                setListRecords([]);
            }
            setLoader(false);
        } catch (error) {
            console.error("getProductDetails", inventoryId, listSupplierId, error);
            setListRecords([]);
            setLoader(false);
        }
    };


    const columns = [
        {
            field: "edit",
            headerName: "",
            width: 75,
            renderCell: (cellValues) => {
                return (
                    <SnpButton variant="contained"
                        mbgcolor="#538796"
                        mpadding="1px"
                        onPointerDown={() => navigate("/dashboard/goldsupplierrecord", { state: { recordId: cellValues.row.id } })}
                    >Edit</SnpButton>
                );
            }
        },
        {
            field: "productImage",
            headerName: "Icon",
            width: 100,
            renderCell: (rowData) => (
                <div>
                    {
                        isEmpty(rowData.row.imagePath) ?
                            <ImageNotSupportedIcon style={{ height: "80px", width: "80px", borderRadius: "20%" }} /> : <img
                                alt=""
                                style={{ height: "80px", width: "80px", borderRadius: "20%" }}
                                src={rowData.row.imagePath && storeApiUrl.BACKEND_BASE_URL + "files/" + rowData.row.imagePath}
                            ></img>
                    }

                </div>
            ),
        },
        {
            field: 'supplierName', headerName: 'Supplier', width: 130, valueGetter: (params) => params.row.supplierName, renderCell: (params) => (
                <p style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>{params.value}</p>
            ),
        },
        {
            field: 'name', headerName: 'Item', width: 150, valueGetter: (params) => params.row.name, renderCell: (params) => (
                <p style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>{params.value}</p>
            ),
        },
        {
            field: 'weight', headerName: 'Weight', width: 150, valueGetter: (params) => params.row.weight, renderCell: (params) => (
                <p style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>{params.value}</p>
            ),
        },
        {
            field: 'unit', headerName: 'Unit', width: 150, valueGetter: (params) => params.row.unit, renderCell: (params) => (
                <p style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>{params.value}</p>
            ),
        },
        {
            field: 'itemStatusStr', headerName: 'Status', width: 120, valueGetter: (params) => params.row.itemStatusStr, renderCell: (params) => (
                <span style={{ color: params.value === 'Active' ? '#0f633b' : "#7a1904" }}>{params.value}</span>
            ),
        }
    ];


    useEffect(() => {
        printDebugLog("ShowGoldSupplierRecord", location.state);
        getSupplierDetails();
        const supId = location.state?.supId;
        const kInvetoryId = location.state?.inventoryId;
        setInventoryId(kInvetoryId);
        if (!isEmpty(supId)) {
            setListSupId(prevListSupId => [...prevListSupId, supId]);
            getProductDetails(kInvetoryId, [supId]);
        } else {
            getProductDetails(kInvetoryId, []);
        }
    }, [location.state, storeApiUrl, storeActiveShopHash]);

    return (
        <SnpBaseLayout
            loader={loader}
            snackbarConfig={{ ...snackbarConfig, onClose: closeSnackbar }}
            dialogConfig={dialogConfig}
        >
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <SnpButton variant="contained" onPointerDown={() => navigate("/dashboard/showproduct")}>
                        Go back
                    </SnpButton>
                </Grid>
                <Grid item xs={12}>
                    <CustomDataGrid
                        getRowId={row => row.id}
                        rows={listRecords}
                        columns={columns}
                        mDensity="compact"
                    />
                </Grid>
            </Grid>
        </SnpBaseLayout>
    )
};


export default ShowGoldSupplierRecord;